var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { actions, Field } from 'react-redux-form';
import { FormGroup } from "../../ReactReduxForms";
import { Translate, t } from "../../I18N";
import api from "../../utils/api";
import { Icon } from "../../UI";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { notify } from "../../Notifications/actions/notificationsActions";
import { RequestParams } from "../../utils/RequestParams";
import { LocalForm } from "../../Forms/Form";
import { FormCaptcha } from "./FormCaptcha";

class ContactForm extends Component {
  constructor(props, context) {
    super(props, context);
    this.submit = this.submit.bind(this);
    this.validators = {
      name: { required: (val) => val && val.length > 2 },
      email: { required: (val) => val },
      message: { required: (val) => val && val.length > 4 },
      captcha: { required: (val) => val && val.text.length }
    };
    this.refreshFn = (refresh) => {
      this.refreshCaptcha = refresh;
    };
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  resetForm() {
    this.formDispatch(actions.reset('contactform'));
  }

  async submit(values) {
    try {
      await api.post(
        'contact',
        new RequestParams({
          name: values.name,
          email: values.email,
          message: values.message,
          captcha: JSON.stringify(values.captcha)
        })
      );
      this.props.notify(t('System', 'Message sent', null, false), 'success');
      this.resetForm();
    } catch (e) {
      if (e.status === 403) {
        this.props.notify(e.json.error, 'danger');
      } else {
        this.props.notify(t('System', 'An error occurred', null, false), 'danger');
        this.resetForm();
      }
    }

    this.refreshCaptcha();
  }

  render() {
    return (/*#__PURE__*/
      _jsx(LocalForm, {
        validators: this.validators,
        model: "contactform",
        className: "contact-form",
        getDispatch: (dispatch) => this.attachDispatch(dispatch),
        onSubmit: this.submit }, void 0, /*#__PURE__*/

      _jsx(FormGroup, { model: ".name" }, void 0, /*#__PURE__*/
      _jsx("label", { className: "form-group-label", htmlFor: "name" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Name"), /*#__PURE__*/
      _jsx("span", { className: "required" }, void 0, "*")
      ), /*#__PURE__*/

      _jsx(Field, { model: ".name" }, void 0, /*#__PURE__*/
      _jsx("input", { type: "text", name: "name", className: "form-control" })
      )
      ), /*#__PURE__*/

      _jsx(FormGroup, { model: ".email" }, void 0, /*#__PURE__*/
      _jsx("label", { className: "form-group-label", htmlFor: "email" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Email"), /*#__PURE__*/
      _jsx("span", { className: "required" }, void 0, "*")
      ), /*#__PURE__*/

      _jsx(Field, { model: ".email" }, void 0, /*#__PURE__*/
      _jsx("input", { type: "email", name: "email", className: "form-control" })
      )
      ), /*#__PURE__*/

      _jsx(FormGroup, { model: ".message" }, void 0, /*#__PURE__*/
      _jsx("label", { className: "form-group-label", htmlFor: "message" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Message"), /*#__PURE__*/
      _jsx("span", { className: "required" }, void 0, "*")
      ), /*#__PURE__*/

      _jsx(Field, { model: ".message" }, void 0, /*#__PURE__*/
      _jsx("textarea", { name: "message", className: "form-control" })
      )
      ), /*#__PURE__*/

      _jsx(FormCaptcha, { refresh: this.refreshFn }), /*#__PURE__*/

      _jsx("button", { type: "submit", className: "btn btn-success" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "paper-plane" }), "\xA0", /*#__PURE__*/

      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Send")
      )
      )
      ));

  }
}





function mapDispatchToProps(dispatch) {
  return bindActionCreators({ notify }, dispatch);
}

export { ContactForm };
export default connect(null, mapDispatchToProps)(ContactForm);